import React from 'react';

function ErrorFragment() {
  return (
    <div>
      <div>
        This link has expired and can no longer be used to grant free access to the article.
      </div>
    </div>
  );
}

export default ErrorFragment;
